export const compareUniverseNames = (a, b) =>
  String(a || '').localeCompare(String(b || ''), undefined, {
    numeric: true,
    sensitivity: 'base',
  });

export const clubLabel = (teamName, serverName) => {
  if (!teamName) return 'Current Team';
  if (!serverName) return teamName;
  return `${teamName} · ${serverName}`;
};

const stringifyId = (value) => {
  if (value == null) return null;
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }
  if (typeof value === 'object') {
    if (value.$oid) return String(value.$oid);
    if (typeof value.toHexString === 'function') return value.toHexString();
    if (value._id && value._id !== value) return stringifyId(value._id);
  }
  return null;
};

const leagueKeys = (leagueRef) => {
  if (!leagueRef) return {};
  if (typeof leagueRef === 'string' || typeof leagueRef === 'number') {
    return { raw: String(leagueRef) };
  }
  if (typeof leagueRef !== 'object') return {};
  return {
    id: stringifyId(leagueRef._id || leagueRef.id),
    code: leagueRef.code || null,
    name: leagueRef.name || null,
  };
};

const universeByLeague = (universes, predicate) =>
  universes.find((item) => (item.leagues || []).some(predicate));

export const resolveUniverseName = (leagueRef, universes = []) => {
  if (!leagueRef || !universes.length) return null;

  const { id, code, name, raw } = leagueKeys(leagueRef);

  if (code) {
    const byCode = universeByLeague(
      universes,
      (league) => league.code === code
    );
    if (byCode) return byCode.name;
  }

  if (id) {
    const byId = universeByLeague(
      universes,
      (league) => stringifyId(league._id) === id
    );
    if (byId) return byId.name;
  }

  if (raw) {
    const byRawCode = universeByLeague(
      universes,
      (league) => league.code === raw
    );
    if (byRawCode) return byRawCode.name;

    const byRawId = universeByLeague(
      universes,
      (league) => stringifyId(league._id) === raw
    );
    if (byRawId) return byRawId.name;

    const byUniverse = universes.find(
      (item) => item.name === raw || stringifyId(item._id) === raw
    );
    if (byUniverse) return byUniverse.name;
  }

  if (name) {
    const byUniverseName = universes.find((item) => item.name === name);
    if (byUniverseName) return byUniverseName.name;

    const nameMatches = universes.filter((item) =>
      (item.leagues || []).some((league) => league.name === name)
    );
    if (nameMatches.length === 1) return nameMatches[0].name;
  }

  return null;
};

export const leagueRefFromTeam = (team) =>
  team?.league ||
  team?.league_id ||
  team?.leagueId ||
  team?.universe ||
  team?.server ||
  null;

export const leagueRefFromUser = (user) =>
  user?.league ||
  user?.universe ||
  user?.server ||
  leagueRefFromTeam(user?.team) ||
  null;
